<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Title tag="h2">Edificaciones instrumentadas</Title>
      <div class="filters">
        <div class="filtros">
          <div>
            <span>Filtrar por región: </span>
            <select id="regiones" v-model="selectRegion">
              <option value="" disabled>Selecciona una región</option>
              <option
                v-for="region in regiones"
                :key="region.name"
                :value="region.name"
              >
                {{ region.name }}
              </option>
            </select>
          </div>

          <div>
            <span>Seleccione el distrito: </span>
            <select
              id="distritos"
              v-model="selectDistrito"
              @change="getFilters"
              :disabled="!selectRegion"
            >
              <option value="" disabled>Selecciona un distrito</option>
              <option
                v-for="distrito in distritosFiltrados"
                :key="distrito.code"
                :value="distrito.code"
              >
                {{ distrito.name }}
              </option>
            </select>
          </div>
        </div>
        <div>
          <span>Mostrar </span>
          <select id="options" v-model="selectCantidades" @change="getFilters">
            <option v-for="option in options" :key="option" :value="option">{{
              option
            }}</option>
          </select>
          <span> edificaciones</span>
        </div>
      </div>
      <TableUi>
        <template v-slot:header>
          <tr>
            <th>Nombre del edificio</th>
            <th>Región</th>
            <th>Distrito</th>
            <th>Visualización</th>
          </tr>
        </template>
        <template v-slot:body v-if="edificaciones != null">
          <tr v-for="edificacion in edificaciones" :key="edificacion.id">
            <td>{{ edificacion.nombre }}</td>
            <td>{{ edificacion.region }}</td>
            <td>{{ getUbicacion(edificacion.codigo_sotano) }}</td>
            <td>
              <div class="botones">
                <Button
                  tag="button"
                  @click="verEdificacion(edificacion.codigo_sotano, 'sotano')"
                  theme="primary"
                  v-if="edificacion.num_eventos_sotano !== 0"
                >
                  Sótano ({{ edificacion.num_eventos_sotano }})
                </Button>
                <Button
                  tag="button"
                  @click="verEdificacion(edificacion.codigo_sotano, 'sotano2')"
                  theme="primary"
                  v-if="edificacion.num_eventos_sotano2 !== 0"
                >
                  Sótano 2 ({{ edificacion.num_eventos_sotano2 }})
                </Button>
                <Button
                  tag="button"
                  @click="verEdificacion(edificacion.codigo_azotea, 'azotea')"
                  theme="primary"
                  v-if="edificacion.num_eventos_azotea !== 0"
                >
                  Azotea ({{ edificacion.num_eventos_azotea }})
                </Button>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:body v-else>
          <td colspan="4" style="text-align:center;">
            Data no disponible en estos momentos
          </td>
        </template>
      </TableUi>
      <div class="pagination">
        <Button
          tag="button"
          theme="primary"
          @click="loadPage(currentPage - 1)"
          :disabled="currentPage === 1"
          >Anterior</Button
        >
        <Button
          tag="button"
          theme="primary"
          @click="loadPage(currentPage + 1)"
          :disabled="!hasNextPage"
          >Siguiente</Button
        >
      </div>
    </Container>
  </main>
</template>

<script>
import axios from "axios";

import Trail from "@/components/common/Trail.vue";
import Container from "@/components/ui/objects/Container.vue";
import Title from "@/components/ui/atoms/Title.vue";
import TableUi from "@/components/ui/objects/TableUi.vue";
import Button from "@/components/ui/atoms/Button.vue";

export default {
  components: {
    Trail,
    Container,
    Title,
    TableUi,
    Button,
  },
  data() {
    return {
      edificaciones: null,
      selectCantidades: "10",
      options: ["10", "25", "50", "100"],
      selectDistrito: "BA",
      selectRegion: "Lima",
      currentPage: 1,
      hasNextPage: true,
      regiones: [
        {
          name: "Arequipa",
        },
        {
          name: "Lima",
        },
      ],
      distritos: [
        { code: "AR", region: "Arequipa", name: "Mollendo" },
        { code: "BA", region: "Lima", name: "Barranco" },
        { code: "BE", region: "Lima", name: "Bella Vista" },
        { code: "CH", region: "Lima", name: "Chorrillos" },
        { code: "JM", region: "Lima", name: "Jesús María" },
        { code: "VI", region: "Lima", name: "La Victoria" },
        { code: "LI", region: "Lima", name: "Lima" },
        { code: "LC", region: "Lima", name: "Lince" },
        { code: "MM", region: "Lima", name: "Magdalena del Mar" },
        { code: "MI", region: "Lima", name: "San Miguel" },
        { code: "MF", region: "Lima", name: "Miraflores" },
        { code: "SA", region: "Lima", name: "Santa Anita" },
        { code: "BO", region: "Lima", name: "San Borja" },
        { code: "SI", region: "Lima", name: "San Isidro" },
        { code: "SS", region: "Lima", name: "Santiago de Surco" },
        { code: "SU", region: "Lima", name: "Surquillo" },
        { code: "VS", region: "Lima", name: "Villa el Salvador" },
      ],
    };
  },
  mounted() {
    let token = localStorage.getItem("token");
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios
      .get(
        `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/edificaciones/${this.selectDistrito}/${this.selectCantidades}/${this.currentPage}`
      )
      .then((response) => {
        this.edificaciones = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  computed: {
    distritosFiltrados() {
      return this.distritos.filter((d) => d.region === this.selectRegion);
    },
  },
  methods: {
    getFilters() {
      axios
        .get(
          `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/edificaciones/${this.selectDistrito}/${this.selectCantidades}/${this.currentPage}`
        )
        .then((response) => {
          this.edificaciones = response.data;
          this.currentPage = 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    verEdificacion(code, type) {
      this.$router.push(`/edificaciones-instrumentadas/${code}/${type}`);
    },

    loadPage(page) {
      axios
        .get(
          `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/edificaciones/${this.selectDistrito}/${this.selectCantidades}/${page}`
        )
        .then((response) => {
          this.edificaciones = response.data;
          this.currentPage = page;
          this.hasNextPage = this.checkNextPage(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUbicacion(code) {
      let codeDist = code.substr(0, 2);
      let distrito = "";
      switch (codeDist) {
        case "AR":
          distrito = "Mollendo";
          break;
        case "BA":
          distrito = "Barranco";
          break;
        case "BE":
          distrito = "Bella Vista";
          break;
        case "CH":
          distrito = "Chorrillos";
          break;
        case "JM":
          distrito = "Jesús María";
          break;
        case "VI":
          distrito = "La Victoria";
          break;
        case "LI":
          distrito = "Lima";
          break;
        case "LC":
          distrito = "Lince";
          break;
        case "MM":
          distrito = "Magdalena del Mar";
          break;
        case "MF":
          distrito = "Miraflores";
          break;
        case "BO":
          distrito = "San Borja";
          break;
        case "SI":
          distrito = "San Isidro";
          break;
        case "MI":
          distrito = "San Miguel";
          break;
        case "SS":
          distrito = "Santiago de Surco";
          break;
        case "SU":
          distrito = "Surquillo";
          break;
        case "VS":
          distrito = "Villa el Salvador";
          break;
      }
      return distrito;
    },

    checkNextPage(response) {
      return response.data && response.data.length > 9;
    },
  },
};
</script>

<style>
.filters {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.filtros {
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
}

.pagination {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

select {
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #818181;
}

button:disabled {
  color: #a8a8a8 !important;
  background: transparent !important;
  border: 2px solid #a8a8a8 !important;
  pointer-events: none;
}

.botones {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

@media screen and (max-width: 768px) {
  .botones {
    flex-direction: column;
  }
}
</style>
